import { CommerceRepository } from "./repository";
import { mockRepository } from "./mock/mockRepository";
import { shopifyRepository } from "./shopify/shopifyRepository";
import { isShopifyConfigured } from "./shopify/env";

/**
 * Single switch point between the mock repository and the Shopify Storefront
 * API repository. Components import `commerceRepository` from here and never
 * talk to `mockRepository`/`shopifyRepository` or the data files directly.
 *
 * Picks Shopify automatically once REACT_APP_SHOPIFY_STORE_DOMAIN and
 * REACT_APP_SHOPIFY_STOREFRONT_TOKEN are set (see .env.example); otherwise
 * falls back to the local mock data so the app keeps working without a store.
 */
export const commerceRepository: CommerceRepository = isShopifyConfigured() ? shopifyRepository : mockRepository;

export * from "./types";
export type { CommerceRepository } from "./repository";
